import { supabase } from "@/lib/supabase";
import BaseService from "@/services/BaseService.ts";

/**
 * Service class for handling Crypto-price-related operations
 *
 * @class CryptoPriceService
 * @example
 * const service = new CryptoPriceService();
 * const payments = await service.getReitDividendPayments(userId);
 */
export class CryptoPriceService extends BaseService {

  /**
   * Fetch all crypto prices given a list of symbols
   * @param {string[]} symbols Symbols
   */
  async fetchPrices(symbols: string[]): Promise<CryptoPrice[]> {
    try {
      const { data, error } = await supabase.functions.invoke('crypto-price', {
        body: { symbols },
      });
      if (error) throw error;
      return data;
    } catch (error) {
      console.error("Error fetching Crypto prices", error);
      await this.handleError(error);
    }
  }

  async fetchPriceChart(symbol: string, days: number = 7): Promise<Array<[number, number]>> {
    try {
      const { data, error } = await supabase.functions.invoke('crypto-price', {
        body: { type: 'chart', symbol, days },
      });
      if (error) throw error;
      return data
    } catch (error) {
      console.error("Error fetching Crypto prices", error);
      await this.handleError(error);
    }
  }

}

export default new CryptoPriceService();
